import styled from 'styled-components';

const Wrapper = styled.div<{ bottom?: string }>`
  width: 100%;
  min-height: calc(100vh - ${p => p.bottom || '82px'});
  background: #ffffff;
  border-radius: ${props => props.theme.radius.md};
  padding: ${props =>
    `0px ${props.theme.app.padding.horizontal} ${props.theme.app.padding.vertical} ${props.theme.app.padding.horizontal}`};
`;

export default Wrapper;

export const WrapperPOSProductItems = styled.div`
  width: 100%;
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;
